// extracted by mini-css-extract-plugin
export default {"floatMenu":"RowOperationsButton__floatMenu___HXSuz","dots":"RowOperationsButton__dots____PPGn"};